import { useUpsertIncidentStatusSummary } from 'components/IAP/hooks/incidentStatusSummaryHooks';
import { ResponderDeathsFormFields } from 'types/iapBaseTypes';

import ResponderCountTable from './ResponderCountTable';

const ResponderDeathsTable = ({
  statusSummaryId,
  originalResponderDeaths,
  readOnly = false,
}: {
  statusSummaryId: string;
  originalResponderDeaths: ResponderDeathsFormFields;
  readOnly?: boolean;
}) => {
  const upsertIncidentStatusSummary =
    useUpsertIncidentStatusSummary(statusSummaryId);

  return (
    <ResponderCountTable
      label="Responder Deaths"
      testId="ics209-responder-deaths"
      thisReportingPeriodLabel="Total Responder Deaths This Reporting Period"
      totalLabel="Total Responder Deaths To Date"
      thisReportingPeriod={
        originalResponderDeaths?.responderDeathsThisReportingPeriod ?? 0
      }
      total={originalResponderDeaths?.responderDeathsTotal ?? 0}
      readOnly={readOnly}
      onSave={({ thisReportingPeriod, total }) =>
        upsertIncidentStatusSummary({
          responderDeathsThisReportingPeriod: thisReportingPeriod,
          responderDeathsTotal: total,
        })
      }
    />
  );
};

export default ResponderDeathsTable;
